import { MakeCall } from 'ha/services/apiV2/createMakeCall';

export type ConfirmPayoutMethodCall = (
  userID: number,
  token: string,
) => Promise<{ data: {} }>;

export default (makeCall: MakeCall) => (userID: number, token: string) =>
  makeCall<undefined>('PUT', `/api/v2/user/${userID}/payout-methods/confirm`, {
    data: { token },
  });
